import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { User } from '@/services/types/event/study-king/user.type';

interface UserStore {
  user: User | null;
  setUser: (user: User) => void;
  updateUser: (partialUser: Partial<User>) => void;
  clearUser: () => void;
}

export const useUserStore = create<UserStore>()(
  persist(
    (set) => ({
      user: null,
      setUser: (user) => set({ user }), // ✅ user에 userId + os 포함
      updateUser: (partialUser) =>
        set((state) => ({ user: { ...state.user, ...partialUser } })),
      clearUser: () => set({ user: null }),
    }),
    {
      name: 'user-storage', // localStorage 키 이름
      storage: {
        getItem: (name) => JSON.parse(localStorage.getItem(name) || 'null'),
        setItem: (name, value) =>
          localStorage.setItem(name, JSON.stringify(value)),
        removeItem: (name) => localStorage.removeItem(name),
      },
    },
  ),
);
